import * as consultationTransactionsFormNames from "./consultationTransactionsFormNames";

export const consultationTransactionsInitialValues = {
  [consultationTransactionsFormNames.ROLE_OPERATEUR_FORM_NAME]: "",
  [consultationTransactionsFormNames.OPERATEUR_FORM_NAME]: "",
  [consultationTransactionsFormNames.UTILISATEUR_FORM_NAME]: "",
  [consultationTransactionsFormNames.ID_TRANSACTION_FORM_NAME]: "",
  [consultationTransactionsFormNames.CRITERE_FACTURATION_FORM_NAME]: "",
  [consultationTransactionsFormNames.REFERENCE_DECLENCHEUR_FORM_NAME]: "",
  [consultationTransactionsFormNames.STATUT_TRANSACTION_FORM_NAME]: "",
  [consultationTransactionsFormNames.CODE_PACKAGE_FORM_NAME]: "",
  [consultationTransactionsFormNames.NUMERO_SOUSCRIPTION_FORM_NAME]: "",
  [consultationTransactionsFormNames.MOTIF_ANNULATION_FORM_NAME]: "",
  [consultationTransactionsFormNames.DATE_DE_FORM_NAME]: "",
  [consultationTransactionsFormNames.DATE_A_FORM_NAME]: "",
};

export const annulationTransactionInitialValues = {
  [consultationTransactionsFormNames.ANNULATION_MOTIF_ANNULATION_FORM_NAME]: "",
};
